import React, { useEffect, useState } from "react";
import TopBar from "../../features/FeatureTopBar/components/TopBar";
import AffiliateRequest from "./AffiliateRequest";
import MyAffiliates from "./MyAffiliates";
import GeneralMUIDialog from "../../../components/GeneralMUIDialog/GeneralMUIDialog";
import AddAffiliate from "./AddAffiliate";
import CompanyPopup from "../../../components/popUp/CompanyPopup";
import { useIds } from "../../../hook/AdminContext";

export default function ManageAffiliates() {
  const { setBreadCrumb } = useIds();
  const [openAddAffiliateModal, setOpenAddAffiliateModal] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const [openDetails, setOpenDetails] = useState(false);
  const [targetClient, setTargetClient] = useState(null);

  const [tabToShow, setTabToShow] = useState("requests");
  const handleAddAffilates = () => {
    setOpenAddAffiliateModal(true);
  };
  const handleTabsList = () => {
    const list = [
      {
        title: "Affiliate Requests",
        id: "requests",
      },
      {
        title: "My Affiliations",
        id: "my-affiliates",
      },
    ];
    return list;
  };

  const handleClentDetails = (obj) => {
    setTargetClient(obj);
    setOpenDetails(true);
  };

  useEffect(() => {
    setBreadCrumb([
      {
        name: `Profile`,
        path: `/profile`,
        active: false,
      },
    ]);
  }, []);

  return (
    <div className="w-100">
      {openAddAffiliateModal && (
        <GeneralMUIDialog
          open={openAddAffiliateModal}
          setOpen={setOpenAddAffiliateModal}
          title={"Add Affiliate"}
          content={<AddAffiliate setIsChanged={setIsChanged} />}
          cancelText={"Close"} // cancel button text
          maxWidth={"lg"}
          showActionButton={false}
        />
      )}

      {openDetails && (
        <CompanyPopup
          companyModalOpen={openDetails}
          handleCloseCompanyModal={() => setOpenDetails(false)}
          companyModalData={targetClient}
        />
      )}

      <div className="container-fluid mt-3">
        <div className="d-flex justify-content-between align-items-start heading-main">
          <h3 className="mb-1">Manage Affiliates</h3>
          <div className="d-flex align-items-center">
            {/* <TopBar
              classes="tw-w-[350px] me-3 tw-mb-3"
              items={handleTabsList()}
              cardToOpen={tabToShow}
              setCardToOpen={(value) => {
                setTabToShow(value);
              }}
            /> */}
            <button
              className="btn-outlined-sm tw-mb-3"
              onClick={() => handleAddAffilates()}
            >
              Add Affiliates
            </button>
          </div>
        </div>
      </div>
      <MyAffiliates
        isChanged={isChanged}
        handleClentDetails={handleClentDetails}
        isManagePage={true}
      />
      <AffiliateRequest
        handleClentDetails={handleClentDetails}
        isManagePage={true}
      />
    </div>
  );
}
